// Import Configs
import {
    CRMRequestService,
    postCancelableRequest,
    deleteCancelableRequest,
    CRMRequestServiceDownload,
    CRMRequestDownloadLinkService,
} from './http.config';

const ExecutedReportHttpService = {
    getExecutedReportList: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/ReportResult/List',
        });
    },
    deleteExecutedReport: () => {
        return deleteCancelableRequest({
            requestService: CRMRequestService,
            defaultParams: {},
            endpointPath: ({ executedReportId, type }) => `/ReportResult/Delete?id=${executedReportId}&type=${type}`,
        });
    },
    getExecutedReportResult: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/ReportResult/View`,
        });
    },
    getExecutedReportHistory: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/EventLog/List`,
        });
    },
    downloadExecutedReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestServiceDownload,
            endpointPath: () => `/AdHocReportResult/GetExcel`,
        });
    },
    sendToEmailExecutedReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestDownloadLinkService,
            endpointPath: () => `/AdHocReportResult/GetExcel?isDownload=false`,
        });
    },
    deleteSelectedExecutedReports: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ type }) => `/ReportResult/Delete?type=${type}`,
        });
    },
    archiveExecutedReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ executedReportId }) => `ReportResult/Archive?id=${executedReportId}`,
        });
    },
    archiveExecutedReports: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `ReportResult/Archive`,
        });
    },
    unarchiveExecutedReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ executedReportId }) => `ReportResult/UnarchiveReportResult?id=${executedReportId}`,
        });
    },
    unarchiveExecutedReports: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `ReportResult/UnarchiveReportResult`,
        });
    },
};

export default ExecutedReportHttpService;
